<template>
    <div>
        <vsmallheader></vsmallheader>
        <div>   
            <div class="metter">
                <div>
                    <span style="cursor: pointer;" @click="retrun">教官库 </span>/ {{dongtai}} / 更多</div>
                <div class="mettera">
                    <!-- <el-button   icon="el-icon-arrow-left" @click="retrun"></el-button> -->
                    <div style="display:flex;font-size:18px;font-weight:700">
                        <div style="width:50px"></div>
                        <div style="width:500px">名称</div>
                        <div style="width:200px">创建人</div>
                        <div style="width:200px">观看数量</div>
                        <div style="width:200px">发布时间</div>
                    </div>
                    <ul  v-if="newsss.length!==0">
                        <li v-for="(item,index) in newsss" :key="index" >
                            <div>
                                <div></div>
                                <div style="width:500px" @click="gotoBlogOne(item.id)">{{item.title}}</div>
                                <div style="width:200px" @click="gotoBlogOne(item.id)">{{item.tearchName}}</div>
                                <div style="width:200px" @click="gotoBlogOne(item.id)">{{item.readCount}}</div>
                                <div style="width:200px" @click="gotoBlogOne(item.id)">{{item.createTime}}</div>
                            </div>
                            <!-- <div>{{item.publishTime}}</div> -->
                        </li>
                    </ul>
                    <div v-else>
                        <nodata></nodata>
                    </div>
                    <div class="pageblock">
                    <el-pagination 
                        background 
                        prev-text="上一页"
                        next-text="下一页"
                        layout="total,prev, pager, next,jumper"
                        :page-size="listQuerys.Limit"
                        :current-page.sync="listQuerys.Page"
                        :total="dataCount"
                        v-if="dataCount>0"
                        @current-change="handleCurrentChange"  
                        @size-change="handleSizeChange" 
                        >
                    </el-pagination>
                </div>
                </div>
            </div>
        </div>
        <!-- <linecom></linecom> -->
    </div>
</template>
<script>
import * as teacher from '@/api/teacher/teacherInfo.js'
import vsmallheader from '@/views/smallHeader/index'
import linecom from '@/components/linecom/index';

export default {
    components:{
        vsmallheader,linecom
    },
    data(){
        return{
            dongtai:'',
            newsss:'',
            listQuerys: { // 查询条件
                Page: 1,
                Limit: 15,
                type:this.$route.query.type
            },
            dataCount:0
        }
    },
    created(){
        this.getnewsList()
        if(this.$route.query.type==1){
            this.dongtai='心得'
        }else{
            this.dongtai='教案'
        }
    },
    methods:{
        getnewsList(){
            teacher.TeacherBlogsLoad(this.listQuerys).then(res=>{
                this.newsss=res.data
                console.log(this.new)
                this.dataCount=res.count
            })
        },
        handleSizeChange(val) {
            this.listQuerys.Limit = val;
            this.getnewsList();
         },
        handleCurrentChange(val) {
            this.listQuerys.Page = val;
            this.getnewsList();
        },
        retrun(){
            this.$router.go(-1)
        },
        gotoBlogOne(id){
            teacher.TeacherGetBlogReadCount({id:id}).then(res=>{

            })
             this.$router.push({
                path: '/diaoa/blog',
                query: {
                    id:id,
                    type:this.$route.query.type
                }
            })
         },
    },
    
}
</script>
<style scoped>
.metter{
    width: 1200px;
    min-height:700px;
    /* background-color:; */
    margin: 0 auto;
    margin-top: 20px;
    /* margin-bottom: 20px; */
    
}
.mettera{
    padding-top: 20px;
    width: 1200px;
    height: 700px;
    /* background-color:; */
    margin: 0 auto;
    box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    
}

li{
    cursor: pointer;
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    list-style-type:disc;
    display: flex;
    justify-content: space-between;
    margin-right: 30px;
    font-size: 18px;
    margin-top: 8px;
}
li>div:nth-child(1){
    display: flex;
}
li>div:nth-child(1)>div:nth-child(1){
    border-radius: 50%;
    height: 10px;
    width: 10px;
    background-color: #333;
    margin-top: 9px;
    margin-right: 20px;
}
li>div:nth-child(1)>div:nth-child(2){
   overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap;
}
li:hover{
    color: rgb(87, 179, 255);
}
li:hover>div:nth-child(1)>div:nth-child(1){
    border-radius: 50%;
    height: 10px;
    width: 10px;
    background-color: rgb(87, 179, 255);
}
.pageblock{
    margin-top: 20px;
    text-align: center;
}
</style>